export { default } from "./ActivityHeader";
